import {
  AUTHENTICATE,
  LOGOUT,
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT
  // USER_REQUEST
} from "@/store/actions";

import Vue from "vue";
// import localStore from "store2";
import router from "../../router/";

let token = {};
try {
  token = JSON.parse(new URL(window.location).searchParams.get("token"));
} catch (e) {
  console.warn("Default token not found in url: ", e);
}

const state = {
  // userId: localStore("user-id") || null,
  // username: localStore("username") || null,
  // password: localStore("password") || null,
  token: token?.id || "",
  userId: token?.userId || "",
  username: null,
  password: null,
  authenticated: !!token,
  status: token?.id ? "success" : "",
  message: "",
  user: {}
};

console.log("auth state:", state);

const getters = {
  isAuthenticated: state => state.authenticated,
  authStatus: state => state.status,
  currentUser: state => state.user
};

const actions = {
  [AUTHENTICATE]: async function({ state, commit, dispatch }, credentials) {
    console.debug("Action: authenticating, ", credentials);
    //Never logged in before
    //already logged in.

    //initial checks
    if (!credentials) {
      //check mscallback
      try {
        console.log("no credentials: ", this);
        let urlToken = new URL(window.location).searchParams.get("token");

        if (urlToken) {
          // this.$router.push('/auth/login')
          // return this.$msteams.authentication.notifyFailure('invalid-credentials')
          const token = JSON.parse(urlToken);
          if (token.id) {
            console.log("found URL token", token);
            // this.$store.commit('AUTH_SUCCESS', {})
            return dispatch("MS_AUTH", token);
          }
        }
      } catch (e) {
        // console.error(e);
        commit(AUTH_ERROR, e);
      }

      //check existing token
      if (state.token && state.userId) {
        console.log(
          "attempting authentication with tokena nd userID: ",
          state.userId,
          state.token
        );
        try {
          let token = state.token;
          if (!token) {
            console.warn("User currently logged out:", state);
            return false;
          }
          commit(AUTH_REQUEST);

          let user = await Vue.axios.get(`/users/${state.userId}`, {
            headers: { Authorization: token },
            params: {
              filter: {
                include: {
                  rolemapping: true
                }
              }
            }
          });

          if (!user.data) {
            commit(AUTH_ERROR);
            throw new Error("token expired");
          }
          commit(AUTH_SUCCESS, { user: user.data });
          return true;
        } catch (e) {
          commit(AUTH_ERROR, e);
        }
      }

      if (state.username && state.password) {
        credentials = { username: state.username, password: state.password };
      } else {
        return;
      }
    }

    try {
      commit(AUTH_REQUEST);
      var resp = await Vue.axios({
        headers: { Authorization: undefined },
        url: "users/marcologin",
        data: credentials,
        method: "POST"
      });
      if (!resp.data) {
        throw new Error("Unable to login");
      }
      const token = resp.data.id;
      const userId = resp.data.userId;

      console.log("autheticating check from marcoLogin: ", resp);

      var user = await Vue.axios({
        headers: { Authorization: token },
        url: `users/${userId}`,
        params: {
          filter: {
            include: {
              rolemapping: true
            }
          }
        }
      });

      commit(AUTH_SUCCESS, {
        token,
        userId,
        username: credentials.username,
        password: credentials.password,
        user: user.data
      });
      await dispatch("LOAD_CONFIG");
      commit("APP_READY");

      return resp;
    } catch (err) {
      // console.warn(err);
      commit(AUTH_ERROR, err);
      throw err;
    }
  },
  [LOGOUT]: async ({ commit }) => {
    commit(AUTH_LOGOUT);
  },
  MS_AUTH: async ({ commit }, token) => {
    commit(AUTH_REQUEST);
    try {
      let user = await Vue.axios.get(`users/${token.userId}`, {
        headers: { Authorization: token.id },
        params: {
          filter: {
            include: {
              rolemapping: true
            }
          }
        }
      });
      if (user.data) {
        user = user.data;
      }

      commit(AUTH_SUCCESS, {
        token: token.id,
        userId: token.userId,
        username: user.username,
        password: null,
        user: user
      });

      //eslint-disable-next-line
      // debugger

      router.replace(window.location.pathname);

      window.location.search = "";
      return true;
      // console.debug("token user: ", user);
    } catch (e) {
      console.error("Error authenticating with MS", e);
      throw e;
    }
  }
};

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = "authenticating";
  },
  [AUTH_SUCCESS]: (state, auth_data) => {
    state.status = "success";
    state.authenticated = true;
    if (auth_data && auth_data.token) state.token = auth_data.token;
    if (auth_data && auth_data.userId) state.userId = auth_data.userId;
    if (auth_data && auth_data.username) state.username = auth_data.username;
    if (auth_data && auth_data.password) state.password = auth_data.password;
    if (auth_data && auth_data.user) state.user = { ...auth_data.user };

    Vue.axios.defaults.headers.common["Authorization"] = state.token;

    // localStore("user-id", state.userId);
    // localStore("username", state.username);
    // localStore("password", state.password);
  },
  [AUTH_ERROR]: state => {
    state.status = "error";
    state.authenticated = false;
    // localStore("user-id", null);
    // localStore("username", null);
    // localStore("password", null);
  },
  [AUTH_LOGOUT]: state => {
    state.token = "";
    state.status = "";
    state.authenticated = false;
    // localStore("user-id", null);
    // localStore("username", null);
    // localStore("password", null);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
